import * as actionTypes from '../actions/Actions'

export const openChangePassModal = (response) => ({ type: actionTypes.SHOW_CHANGE_PASS_MODAL, response });
export const closeChangePassModal = () => ({ type: actionTypes.CLOSE_CHANGE_PASS_MODAL });
export const load = () => ({type: actionTypes.LOAD});
export const unLoad = () => ({type: actionTypes.UNLOAD});